import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import {
  IGlobalRolesState,
  IGlobalTeamsState,
  selectRolesList,
  selectTeams,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { createStructuredSelector } from 'reselect'
import UserViewPage from '../components/UserViewPage'
import {
  actionCreators,
  IUserViewState,
  selectError,
  selectIsDeleting,
  selectIsLoading,
  selectItem,
  selectPermissions,
  selectScope,
  selectShowConfirmDelete,
} from '../modules/userView'

export default withRouter(
  connect(
    createStructuredSelector<
      ApplicationState,
      IUserViewState & ICurrentUserState & IGlobalRolesState & IGlobalTeamsState
    >({
      error: selectError(),
      isDeleting: selectIsDeleting(),
      isLoading: selectIsLoading(),
      item: selectItem(),
      permissions: selectPermissions(),
      roles: selectRolesList(),
      scope: selectScope(),
      showConfirmDelete: selectShowConfirmDelete(),
      teams: selectTeams(),
      user: selectCurrentUser(),
    }),
    actionCreators,
  )(UserViewPage),
)
